<template>
    <div class="payment-success">
        <h1>{{ $t('template.paymentSuccess.success') }}</h1>
        <i18n-t keypath="template.paymentSuccess.text" tag="p">
            <template #price><b>1$</b></template>
            <template #plan>
                <br />
                <span class="payment-success__plan">{{
                    $t('template.paymentSuccess.activated', { plan: $t('template.paymentSuccess.plans.advanced') })
                }}</span>
                <br />
            </template>
        </i18n-t>
        <p>
            <b>{{ $t('template.paymentSuccess.redirect', { seconds: timer }) }}</b>
        </p>
    </div>
</template>

<script>
export default {
    name: 'PaymentSuccess',
    components: {},
    props: {
        timer: {
            type: Number,
        },
    },
    data() {
        return {
            plan: 'advanced',
        };
    },
};
</script>

<style lang="scss">
.payment-success {
    display: block;
    width: 100%;
    h1 {
        margin-top: 0;
        font-size: 32px;
        margin-bottom: 24px;
    }
    p {
        color: #808080;
    }
    span {
        color: #3aa71f;
    }
    &__plan {
        font-weight: 500;
        color: #3aa71f;
    }
}
</style>
